import { useNode } from "@craftjs/core";
import React, { useState } from "react";

import {
  ColorInput,
  Panel,
  SpacerInput,
  ToggleInput,
  TextInput,
  OptionsInput,
  PaddingInput,
  Tabs,
  FormatOptionsInput,
} from "./../../ui-kit";
import {
  PencilActiveIcon,
  PaintIcon,
  ButtonIcon,
  JustifyIcon,
  JustifyActiveIcon,
  LeftALignIcon,
  LeftALignActiveIcon,
  CenterAlignIcon,
  CenterAlignActiveIcon,
  RightAlignIcon,
  RightAlignActiveIcon,
  SettingsIcon,
} from "../../../assets/ui-icons";
import RightBar from "../../ui-kit/rightbar";
import { isUpdatedFromDefault } from "../../utils";
import { IconPack } from "../../../assets/icon-pack";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSButtonSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const [isActive, setIsActive] = useState("general");

  const {
    textColor = "#fff",
    link,
    linkColor,
    openInNewTab,
    align,
    padding = { top: "10px", bottom: "10px", left: "10px", right: "10px" },
    backgroundColor = "#055099",
    noFollow,
    noReferrer,
  } = props;

  const General = () => {
    return (
      <>
        <SpacerInput>
          <FormatOptionsInput label={"Font Style"} />
          <TextInput
            minLength={INPUT_LIMITS["outbound-link"].minlength}
            maxLength={INPUT_LIMITS["outbound-link"].maxlength}
            value={link}
            onChange={(val) => {
              setProp((props) => {
                props.link = val.target.value;
              });
            }}
            label={"Link"}
          />
          <ToggleInput
            resetValue={undefined}
            label="Open in new tab"
            value={openInNewTab}
            onChange={(val) => {
              setProp((props) => {
                props.openInNewTab = val;
              });
            }}
          />
          <ToggleInput
            resetValue={undefined}
            label="No Follow"
            value={noFollow}
            onChange={(val) => {
              setProp((props) => {
                props.noFollow = val;
              });
            }}
          />
          <ToggleInput
            resetValue={undefined}
            label="No Referrer"
            value={noReferrer}
            onChange={(val) => {
              setProp((props) => {
                props.noReferrer = val;
              });
            }}
          />
          <OptionsInput
            label={"Alignment"}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
                props.textAlign = val;
              });
            }}
            options={[
              {
                label: "Justify",
                value: "justify",
                icon: <JustifyIcon width={"20px"} />,
                active: <JustifyActiveIcon width={"20px"} />,
              },
              {
                label: "Left",
                value: "left",
                icon: <LeftALignIcon width={"20px"} />,
                active: <LeftALignActiveIcon width={"20px"} />,
              },
              {
                label: "Center",
                value: "center",
                icon: <CenterAlignIcon width={"20px"} />,
                active: <CenterAlignActiveIcon width={"20px"} />,
              },
              {
                label: "Right",
                value: "right",
                icon: <RightAlignIcon width={"20px"} />,
                active: <RightAlignActiveIcon width={"20px"} />,
              },
            ]}
          />
        </SpacerInput>
      </>
    );
  };

  const Styles = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        <Panel label={"Colors"} isOpen={true}>
          <SpacerInput>
            <ColorInput
              resetValue={"#fff"}
              value={textColor}
              onChange={(val) => {
                setProp((props) => {
                  props.textColor = val;
                });
              }}
              label={"Text"}
              useTextColorPalette={true}
              supportSelection={true}
            />
            <ColorInput
              resetValue={"#055099"}
              value={backgroundColor}
              onChange={(val) => {
                setProp((props) => {
                  props.backgroundColor = val;
                });
              }}
              label={"Background"}
            />
            <ColorInput
              value={linkColor}
              onChange={(val) => {
                setProp((props) => {
                  props.linkColor = val;
                });
              }}
              label={"Link"}
              useTextColorPalette={true}
              supportSelection={true}
            />
          </SpacerInput>
        </Panel>
      </div>
    );
  };

  const Advance = () => {
    return (
      <SpacerInput>
        <PaddingInput
          value={padding}
          onChange={(val) => {
            setProp((props) => {
              props.padding = val;
            });
          }}
        />
      </SpacerInput>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Advanced",
      key: "advanced",
      icon: IconPack.Settings,
      children: Advance(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between gap-5">
          <RightBar title={"Button"} icon={<ButtonIcon />} />
        </div>
        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />
        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
